import { render } from "./ClassicalNotPurchased.vue?vue&type=template&id=4abd18e2"
import script from "./ClassicalNotPurchased.vue?vue&type=script&lang=js"
export * from "./ClassicalNotPurchased.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__